import { Link, useMatch } from "react-router-dom"
import cn from "classnames"

import style from "./styles.module.scss"

import { NonImgAvatar } from "components/Avatar"

export function PsyAvatar({
    className,
    name,
    isAdaptive,
    dataTestId = "psy-avatar",
}: {
    className?: string
    name: string
    isAdaptive?: boolean
    dataTestId?: string
}) {
    const match = useMatch("/psychologist-account/settings")
    const avatar = (
        <NonImgAvatar
            size="XS"
            className={cn(style.headerUserPicture, className)}
            isAdaptive={isAdaptive}
            data-testid={dataTestId}
        >
            {name}
        </NonImgAvatar>
    )

    if (match) return avatar

    return (
        <Link
            to="/psychologist-account/settings"
            className={cn(style.headerUserPictureLink, className)}
            data-testid={dataTestId}
        >
            {avatar}
        </Link>
    )
}
